import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';

import { FacilitiesV2 } from './FacilitiesV2';
import {
  FacilitiesV2DispatchProps,
  FacilitiesV2OwnProps,
  FacilitiesV2StoreProps,
} from './FacilitiesV2.types';

const mapStateToProps = (state): FacilitiesV2StoreProps => ({
  property: entitySelectors.getProperty(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  facilitiesCategories: entitySelectors.getFacilitiesCategories(state),
  userHasAccessToFacilities: guestSelectors.userHasAccessToSpaEntity(state, 'facilities'),
});

const mapDispatchToProps = (dispatch): FacilitiesV2DispatchProps =>
  bindActionCreators({ changeJourneyParam }, dispatch);

export const FacilitiesV2Connected: React.ComponentType<FacilitiesV2OwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(FacilitiesV2);
